import React, {useEffect, useState} from 'react';
import {Line} from '@ant-design/charts';
import {ConfigProvider, DatePicker} from "antd";
import locale from "antd/es/locale/sr_RS"
import {useSelector} from "react-redux";
import {installationSelect} from "../../redux-store/selectors";
import api from "../../api/apiInterceptor";
import moment from "moment";

const {RangePicker} = DatePicker;

function DeviceHistoryChart({deviceId, parametersNames}) {

    const installationSelectValue = useSelector(installationSelect)

    const [range, setRange] = useState([moment().subtract(1, "w"), moment()])
    const [data, setData] = useState([])
    const [config, setConfig] = useState({
        data,
        xField: 'time',
        yField: 'value',
        legend: true,
        seriesField: 'key',
        stepType: 'hv',
        xAxis: {
            type: 'time'
        },
        tooltip: {
            shared: true,
            fields: ['time', 'value'],
            formatter: (datum) => {
                return { name: moment(datum.time).format("HH:mm "), value: datum.value };
            }
        }
    })
    const [loader, setLoader] = useState(false)
    const [dates, setDates] = useState([moment().subtract(1, "w"), moment()]);

    const fetchDeviceHistory = async () => {
        setLoader(true)
        let result = await api.post(`/api/installations/${installationSelectValue.value}/stats`,
            {
                "since": range[0],
                "until": range[1],
                "deviceId": deviceId,
                "parameters": parametersNames
            }
        )
        setData(result.data.map((item) => {
            return {
                value: item.value,
                time: item.time,
                key: item.key
            }
        }))
        setLoader(false)
    }

    useEffect(() => {
        if (parametersNames.length === 0 || !range) setData([])
        if (deviceId && parametersNames.length && range?.length) {
            fetchDeviceHistory()
        }
    }, [range, deviceId, parametersNames])

    useEffect(() => {
        setConfig({
            data,
            xField: 'time',
            yField: 'value',
            legend: !!data.length,
            seriesField: 'key',
            stepType: 'hv',
            xAxis: {
                type: 'time'
            },
            tooltip: {
                shared: true,
                fields: ['time', 'value'],
                formatter: (datum) => {
                    return { name: moment(datum.time).format("HH:mm "), value: datum.value };
                },
            }
        })
    }, [data])

    const disabledDate = (current) => {
        if (!dates) {
            return false;
        }

        const tooLate = dates[0] && current.diff(dates[0], 'month') > 1;
        const tooEarly = dates[1] && dates[1].diff(current, 'month') > 1;
        return !!tooEarly || !!tooLate;
    };

    return <>
        <ConfigProvider locale={locale}>
            <RangePicker
                disabledDate={disabledDate}
                onCalendarChange={(val) => setDates(val)}
                onChange={(e) => setRange(e)}
                value={range}
                showTime format={"DD.MM.YYYY. HH:mm"}
            />
        </ConfigProvider>
        <Line loading={loader} {...config} />
    </>;
}

export default DeviceHistoryChart;
